import { Vector3 } from "three";
import { InstanceState } from "../../../instance-service/instance-state.service";
import { postActions } from "./post.actions";
import { postSelectors } from "./post.selector";
import { PostEffects } from "./post.effects";
import { postReducer } from "./post.reducer";
import { StateServices } from "../../../instance-service/i-state-services";
import { PostBlueprint } from "../post";

export interface PostState {
  images: {
    fileId: string,
  }[],
  text: string
}

export const initialState: PostState = {
  images: [],
  text: "Example text: Lorem ipsum dolor sit amet"
};

export function makeState(blueprint: PostBlueprint) {
  let state = new InstanceState(
    blueprint.id, 
    postActions, 
    postSelectors,
    PostEffects,
    postReducer,
    blueprint.stateServices,
    blueprint
  )
  return state
}
